export const dummyTableData = {
  Barnsmuir: {
    GH1: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH2: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH3: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH4: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH5: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH6: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH7: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH8: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH9: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH10: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
  },
  "Isle Fruits": {
    GH1: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH2: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH3: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH4: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH5: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH6: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH7: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH8: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH9: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
    GH10: {
      Zara: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Centenary: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Florence: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
      Jubilee: {
        "GH Harvest Percentage": [100, 100, 100, 100, 100, 100, 100],
        "Harvest Criteria": [1, 1, 1, 1, 1, 1, 1],
      },
    },
  },
};
